import React from "react";

type ArrowProps = {
    isActive?: boolean;
    color?: string;
    className?: string;
    sizeStyle?: string;
};

const Arrow: React.FC<ArrowProps> = ({
    isActive = false,
    sizeStyle = "h-[24px] w-[24px]",
    color = "#555B51",
    className = "",
}) => {
    return (
        <svg
            className={`${sizeStyle} shrink-0 transition-all duration-300 ${className}
        ${isActive ? "rotate-180" : ""}`}
            xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M6 9L12 15L18 9" stroke="#405465" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
};

export default Arrow;
